import React, { Component } from 'react';
export default class ContactUs extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="contact">
          <div className="row">
            <aside className="eigth columns footer-widgets">
              <div className="widget">
                <h4>Feel free to contact me on this email or through my social channels!</h4>
                <a href={`mailto:${resumeData.mailId}`}><h4>Email :  {resumeData.mailId}</h4></a>
                <br/>
                <h4>Sign up to my mailing list to keep updated with my projects!</h4>
                <a href="https://linktr.ee/srinibass_" target="_blank" rel="noopener noreferrer"><h4>{resumeData.codeSite}</h4></a>
              </div>
            </aside>
          </div>
        </section>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/contactus/contactus.js